import React, { useEffect, useRef } from 'react';
import { trackMetaCustom } from '../lib/metaPixel';

const VIDEO_ID = '7VPERxy4NnY';

const loadYouTubeApi = () =>
  new Promise((resolve) => {
    if (window.YT && window.YT.Player) {
      resolve(window.YT);
      return;
    }
    if (!document.getElementById('youtube-iframe-api')) {
      const script = document.createElement('script');
      script.id = 'youtube-iframe-api';
      script.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(script);
    }
    const previous = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (typeof previous === 'function') previous();
      resolve(window.YT);
    };
  });

const trackVideoEvent = (name, params) => {
  if (window.gtag) window.gtag('event', name, params);
  trackMetaCustom(name === 'video_start' ? 'VideoPlay' : 'VideoProgress', params);
};

const HomeVideo = () => {
  const containerRef = useRef(null);
  const playerRef = useRef(null);
  const startedRef = useRef(false);
  const milestonesRef = useRef({ 25: false, 50: false, 75: false, 100: false });
  const intervalRef = useRef(null);

  useEffect(() => {
    let cancelled = false;

    loadYouTubeApi().then((YT) => {
      if (cancelled || !containerRef.current) return;

      playerRef.current = new YT.Player(containerRef.current, {
        videoId: VIDEO_ID,
        playerVars: { rel: 0, modestbranding: 1 },
        events: {
          onStateChange: (event) => {
            if (event.data === YT.PlayerState.PLAYING) {
              if (!startedRef.current) {
                startedRef.current = true;
                trackVideoEvent('video_start', {
                  video_title: 'Your Setl',
                  video_provider: 'youtube',
                  video_id: VIDEO_ID,
                });
              }
              if (!intervalRef.current) {
                intervalRef.current = setInterval(() => {
                  const player = playerRef.current;
                  if (!player || !player.getDuration) return;
                  const duration = player.getDuration();
                  if (!duration) return;
                  const percent = (player.getCurrentTime() / duration) * 100;
                  [25, 50, 75].forEach((mark) => {
                    if (percent >= mark && !milestonesRef.current[mark]) {
                      milestonesRef.current[mark] = true;
                      trackVideoEvent('video_progress', {
                        video_title: 'Your Setl',
                        video_provider: 'youtube',
                        video_percent: mark,
                      });
                    }
                  });
                }, 1000);
              }
            }
            if (event.data === YT.PlayerState.ENDED && !milestonesRef.current[100]) {
              milestonesRef.current[100] = true;
              trackVideoEvent('video_complete', {
                video_title: 'Your Setl',
                video_provider: 'youtube',
                video_percent: 100,
              });
            }
          },
        },
      });
    });

    return () => {
      cancelled = true;
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (playerRef.current && playerRef.current.destroy) playerRef.current.destroy();
    };
  }, []);

  return (
    <div
      className="rounded-lg overflow-hidden shadow-2xl"
      style={{ aspectRatio: '16/9' }}
      data-testid="home-video-wrapper"
    >
      <div ref={containerRef} className="w-full h-full" data-testid="home-video-player" />
    </div>
  );
};

export default HomeVideo;
